// extracted by mini-css-extract-plugin
export default {"date":"U1V5t","eventList":"_7mo6c","dateText":"_3CxA6","eventDetails":"AQYtw","dateWithChevron":"_4gPlz","dateChevron":"_4e9YW","close":"rpmSo"};